import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { PasswordService } from '../../services/password.service';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LoadingDirective } from '@styleguide/loading/loading.directive';
import { FormFieldComponent } from '@styleguide/form/form-field/form-field.component';
import { AsyncPipe } from '@angular/common';

enum ComponentStates {
  idle,
  processing,
  validationError,
}

@Component({
  selector: 'kgr-validate-password-reset-token',
  templateUrl: './validate-password-reset-token.component.html',
  styleUrls: ['./validate-password-reset-token.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LoadingDirective, ReactiveFormsModule, FormFieldComponent, AsyncPipe],
})
export class ValidatePasswordResetTokenComponent {
  readonly ComponentStates = ComponentStates;
  readonly invalidCodeError = $localize`Ungültiger Code`;
  state$ = new BehaviorSubject<ComponentStates>(ComponentStates.idle);

  @Output() validatedPasswordResetToken = new EventEmitter<string>();

  form = new FormGroup({
    token: new FormControl('', [Validators.required]),
  });

  constructor(private passwordService: PasswordService) {
    this.form.valueChanges.pipe(takeUntilDestroyed()).subscribe(() => {
      this.state$.next(ComponentStates.idle);
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      this.state$.next(ComponentStates.validationError);

      return;
    }

    this.state$.next(ComponentStates.processing);
    this.passwordService.validateResetToken(this.form.value.token).subscribe({
      next: () => {
        console.log('token correct');
        this.state$.next(ComponentStates.idle);
        this.validatedPasswordResetToken.next(this.form.value.token);
      },
      error: () => {
        this.state$.next(ComponentStates.validationError);
        console.log('token incorrect or other error? todo: handle!');
      },
    });
  }
}
